<template>
  <b-modal
    id="account-deletion-modal"
    class="account-deletion-modal"
    ref="modal"
    header-class="account-deletion-header"
    centered
    @ok="handleSubmit"
    ok-variant="danger"
    :ok-title="$t('Delete')"
    :cancel-title="$t('Cancel')"
  >

    <template #modal-header="{ close }">
      <h3>{{ $t('profile.delete_account.modal.title') }}</h3>
    </template>

    <div>
      <p class="mt-2" v-html="$t('profile.delete_account.modal.content')"></p>
    </div>

  </b-modal>
</template>

<script>
import api from "../../services/api";
import i18n from "../../i18n";

export default {
  emits:[
    'hasValidatedAccountDeletion'
  ],

  methods: {
    handleSubmit(){
      api({
        method: "POST",
        url: '/user/askForAccountDeletion',
      })
        .then((response) => {
          this.$emit('hasValidatedAccountDeletion')
          this.$bvModal.hide('account-deletion-modal')
        })
        .catch(error => {
          if (!error.response) {
            console.log("error", error)
          }
        })
    },
  },
};
</script>

<!-- not scoped car modal --><style>
#identity-to-validate-modal .modal-content,
#identity-to-validate-modal .modal-header,
#identity-to-validate-modal .modal-body,
#identity-to-validate-modal .modal-footer{
  background-color: var(--main-black-dark);
}

</style>



// WEBPACK FOOTER //
// src/views/user/AccountDeletionModal.vue